.error-badge {
  height: 65%;
}

.customs-collapsible-wrapper {
  align-self: stretch;
}

.no-ids-instructions {
  width: 75%;
  margin: auto;
  text-align: center;
}
